import React from 'react'
import { Box, Checkbox } from '@material-ui/core'
import { muiTheme } from 'legacy-theme'
import { ThemeProvider } from '@material-ui/styles'

// Must stay a stable function: `theme={muiTheme}` would make ThemeProvider merge a fresh theme
// object per cell, and withStyles keys its JSS sheet cache by theme identity, so every row would
// re-insert the whole Checkbox rule set into the document.
// It must also never return the outer theme itself: ThemeProvider flags its result as nested, and on
// the app root theme that flag suffixes every global Mui class name (e.g. `MuiCollapse-container-12`),
// which breaks selectors that rely on them — notistack snackbars stop receiving clicks.
const nestedThemes = new WeakMap()
export const toMuiTheme = outerTheme => {
  if (!nestedThemes.has(outerTheme)) {
    nestedThemes.set(outerTheme, { ...outerTheme, ...muiTheme })
  }
  return nestedThemes.get(outerTheme)
}

export const SelectColumnHeader = ({ getToggleAllRowsSelectedProps }) => (
  <ThemeProvider theme={toMuiTheme}>
    <Checkbox {...getToggleAllRowsSelectedProps()} />{' '}
  </ThemeProvider>
)

export const SelectCell = ({ row }) => (
  <ThemeProvider theme={toMuiTheme}>
    <Checkbox {...row.getToggleRowSelectedProps()} />
  </ThemeProvider>
)

export function useSelectColumn(hooks) {
  useConditionalSelectColumn(() => true)(hooks)
}

export const selectionColumnId = '@selection'

export const useConditionalSelectColumn =
  (predicate, className, getInnerClass = row => '') =>
  hooks => {
    const selectColumn = {
      id: selectionColumnId,
      Header: SelectColumnHeader,
      Cell: ({ row }) => {
        const isEnabled = predicate(row)

        return (
          <div className={getInnerClass(row)}>
            {isEnabled ? <SelectCell row={row} /> : <Box width={42} height={42} />}
          </div>
        )
      },
      className,
    }

    hooks.visibleColumns.push(columns => [selectColumn, ...columns])
  }

export default useSelectColumn
